const plans = [
  { id: 1, title: "Primera Inscripción Vehicular" },
  { id: 2, title: "Certificado de Homologación Electrónico (CHI-e)" },
  { id: 3, title: "Seguro Obligatorio de Accidentes Personales (SOAP)" },
  { id: 4, title: "Permiso de Circulación Vehicular (PCV)" },
  { id: 5, title: "TAG" },
  { id: 6, title: "Billetera Electrónica" },
];

export const lastLicenseNumberAvailable = new Array(10)
  .fill(0)
  .map((_, index) => ({ id: `${index}`, name: index }));

export const plansAvailable = [
  {
    id: 1,
    title: "Plan Básico",
    price: "",
    isBestSelling: false,
    needLicenseNumber: false,
    quoteKey: "monto_basico",
    type: "BASICO",
    items: [plans[0], plans[5]],
  },
  {
    id: 2,
    title: "Plan Full",
    price: "",
    isBestSelling: false,
    needLicenseNumber: true,
    quoteKey: "monto_full",
    type: "FULL",
    items: plans,
  },
  {
    id: 3,
    title: "Plan Estándar",
    price: "",
    isBestSelling: false,
    needLicenseNumber: true,
    quoteKey: "monto_estandar",
    type: "ESTANDAR",
    items: [plans[0], plans[1], plans[2], plans[3], plans[5]],
  },
];

export const vehicleTypeAvailable = [
  // 'AUTOMOVIL',
  // 'STATION WAGON',
  "FURGON",
  // 'CAMIONETA',
  // 'MINIBUS',
  // 'JEEP',
  // 'LIMUSINA',
  "BUS",
  // 'MICROBUS',
  // 'OMNIBUS',
  "TRACTOR",
  "MAQUINA AGRICOLA",
  // 'CASA RODANTE',
  // 'MOTORIZADA',
  "MAQUINA INDUSTRIAL",
  // 'AMBULANCIA',
  // 'CARROBOMBA',
  "CHASIS CABINADO",
  // 'COCHE MORTUORIO',
  // 'BUGGI',
  // 'TRACTOR ANFIBIO',
  "CAMION",
  // 'TRACTOCAMION',
  // 'REMOLQUE',
  // 'SEMIREMOLQUE',
  "BICICLETA MOTOR",
  "BICIMOTO",
  "CUADRIMOTO",
  "MOTO",
  "MOTORIZADA",
  "TRICICLO MOTOR",
  "TRIMOTO",
  // 'BICIMOTO',
  // 'TRIMOTO',
  // 'CUADRIMOTO',
  // 'BICICLETA MOTOR',
  // 'TRICICLO MOTOR'
];

// Catálogo oficial (códigos 1-22, en orden; sin 6 ni 9, eliminados el 2026-10-21); `value` = enum FuelType del
// backend. Ver docs/GEDI-1592-*.
export const gasTypes = [
  { value: "GASOLINA", label: "GASOLINA" },
  { value: "DIESEL", label: "DIESEL" },
  { value: "GNC", label: "GNC" },
  { value: "GLP", label: "GLP" },
  { value: "ELECTRICIDAD_BEV_VERDE", label: "ELECTRICIDAD (BEV) - VERDE" },
  { value: "GASOLINA_GLP", label: "GASOLINA/GLP" },
  { value: "GASOLINA_GNC", label: "GASOLINA/GNC" },
  { value: "DIESEL_HEV", label: "DIESEL (HEV)" },
  { value: "DIESEL_ELECT_PHEV_VERDE", label: "DIESEL/ELECT. (PHEV) - VERDE" },
  { value: "GASOLINA_HEV", label: "GASOLINA (HEV)" },
  {
    value: "GASOLINA_ELECT_PHEV_VERDE",
    label: "GASOLINA/ELECT. (PHEV) - VERDE",
  },
  { value: "GNL", label: "GNL" },
  { value: "HIDROGENO_VERDE", label: "HIDROGENO - VERDE" },
  { value: "GASOLINA_MHEV", label: "GASOLINA (MHEV)" },
  { value: "DIESEL_MHEV", label: "DIESEL (MHEV)" },
  { value: "GASOLINA_REEV", label: "GASOLINA (REEV)" },
  { value: "DIESEL_REEV", label: "DIESEL (REEV)" },
  {
    value: "GASOLINA_ELECT_P_REEV_VERDE",
    label: "GASOLINA/ELECT. (P-REEV) - VERDE",
  },
  {
    value: "DIESEL_ELECT_P_REEV_VERDE",
    label: "DIESEL/ELECT. (P-REEV) - VERDE",
  },
  { value: "NO_INFORMADO", label: "NO INFORMADO" },
];

const convertToOptionType = (items) =>
  items.map((label) => ({ value: label, label }));

export const vehicleType = convertToOptionType(vehicleTypeAvailable);
export const personType = convertToOptionType(["NATURAL", "JURÍDICA"]);
export const dispatchPlace = convertToOptionType([
  "DOMICILIO",
  "LOCAL DE COMPRA",
]);

export const billType = convertToOptionType([
  "Factura",
  "Nota de Crédito",
  "DS55",
]);
